import {
  GraduationCap,
  ShieldCheck,
  BookOpen,
  Gavel,
} from "lucide-react";

const SPECIALIZATIONS = [
  "Implantodontia",
  "Ortodontia",
  "Endodontia",
  "Odontologia Legal",
  "Odontologia do Trabalho",
  "Perícia Judicial Odontológica",
  "Assistência Técnica Judicial",
];

const CREDENTIALS = [
  {
    icon: GraduationCap,
    title: "Formação Multidisciplinar",
    text: "Pós-graduações em sete áreas distintas da Odontologia — base sólida para análises técnicas completas e fundamentadas.",
  },
  {
    icon: ShieldCheck,
    title: "Atuação Imparcial",
    text: "Perito judicial e assistente técnico com conduta ética, rigor científico e absoluto compromisso com a verdade dos fatos.",
  },
  {
    icon: BookOpen,
    title: "Produção Técnica",
    text: "Laudos, pareceres e quesitos elaborados conforme normas do CFO, fundamentados em evidências científicas atualizadas.",
  },
  {
    icon: Gavel,
    title: "Experiência Forense",
    text: "Auxílio a magistrados, advogados, empresas e particulares em processos cíveis, criminais, trabalhistas e administrativos.",
  },
];

export const About = () => {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-[#050505]"
    >
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {/* Image column */}
          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] overflow-hidden border border-[#D4AF37]/20">
              <img
                src="https://customer-assets.emergentagent.com/job_judicial-dental/artifacts/mis2efd4_WhatsApp%20Image%202026-06-03%20at%2019.18.20.jpeg"
                alt="Dr. Sandrey Miranda Nobre"
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/40 via-transparent to-transparent pointer-events-none" />
            </div>
            <div className="absolute -bottom-6 -right-6 w-24 h-24 border-r border-b border-[#D4AF37] hidden md:block" />
            <div className="absolute -top-6 -left-6 w-24 h-24 border-l border-t border-[#D4AF37]/60 hidden md:block" />
          </div>

          {/* Content column */}
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#D4AF37]" />
              <span className="text-xs tracking-[0.32em] uppercase text-[#D4AF37]">
                Sobre o Profissional
              </span>
            </div>

            <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white leading-tight tracking-tight">
              Dr. Sandrey Miranda{" "}
              <span className="italic text-[#D4AF37]">Nobre</span>.
            </h2>
            <p className="mt-3 text-sm sm:text-base text-[#D4AF37]/90 tracking-wide">
              Cirurgião-Dentista · CRO 29.826
            </p>
            <p className="mt-1 text-sm sm:text-base text-white/70 tracking-wide">
              Perito Judicial Odontológico · Assistente Técnico Judicial
            </p>

            <div className="mt-8 space-y-5 text-white/70 leading-relaxed">
              <p>
                Cirurgião-Dentista com ampla qualificação acadêmica e atuação
                especializada em Perícia Judicial Odontológica, Assistência
                Técnica Judicial e Odontologia Legal — auxiliando magistrados,
                advogados, empresas e particulares na análise técnica de
                questões relacionadas à saúde bucal e à responsabilidade
                profissional.
              </p>
              <p>
                Formação avançada em diversas áreas da Odontologia, oferecendo
                atendimento pautado na ética, no rigor científico e na
                atualização constante — tanto na produção de laudos, pareceres
                e avaliações periciais quanto na prática clínica
                especializada.
              </p>
            </div>

            {/* Specializations chips */}
            <div className="mt-10">
              <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37] mb-4">
                Formação & Especializações
              </div>
              <div className="flex flex-wrap gap-2">
                {SPECIALIZATIONS.map((spec, i) => (
                  <span
                    key={i}
                    data-testid={`spec-chip-${i}`}
                    className="text-xs sm:text-sm border border-[#D4AF37]/30 text-white/85 px-4 py-2 hover:border-[#D4AF37] hover:bg-[#D4AF37]/5 transition-colors"
                  >
                    {spec}
                  </span>
                ))}
              </div>
            </div>

            {/* Credentials grid */}
            <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-6">
              {CREDENTIALS.map((item, i) => {
                const Icon = item.icon;
                return (
                  <div
                    key={i}
                    data-testid={`credential-item-${i}`}
                    className="group p-5 border border-[#D4AF37]/15 hover:border-[#D4AF37]/50 transition-all duration-300 hover:-translate-y-1"
                  >
                    <Icon
                      size={28}
                      strokeWidth={1.4}
                      className="text-[#D4AF37] mb-4"
                    />
                    <h3 className="font-serif-display text-lg text-white mb-2">
                      {item.title}
                    </h3>
                    <p className="text-sm text-white/60 leading-relaxed">
                      {item.text}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
